import React, { useState, useEffect } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import "../../common.css";
import "../../investorAcademy.css";
import ChildInvestorAcademyCommon from '../../../../../components/common/InvestorAcademyCommon/ChildInvestorAcademyCommon';
import SelectingWarrentImg from '../../../../../components/common/SelectingWarrentImg';



const ImpliedVolatilities = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    const location = useLocation();
    const history = useHistory();
    const [openLive, setOpenLive] = useState(false);
    const [imageUrl, setImageUrl] = useState('');

    return (
        <div id="investor_academy">
            <div className="imgbg" />
            <div className="mainbg"></div>

            <div id="main" className='warrant-sensitivity liquidity_sec Common_warrent'>
                <div id="maintable" style={{ display: 'table', width: '100%', tableLayout: 'fixed' }}>
                    <div style={{ display: 'table-row' }}>
                        <div id="leftbar" className="hidden-xs" style={{ display: 'table-cell', width: '80px' }} />
                        <div id="maincontainer" style={{ display: 'table-cell', width: '100%' }}>
                            <div id="mainnav">
                                <table style={{ width: '100%', tableLayout: 'fixed', borderBottom: '1px solid #353223' }}>
                                    <tbody><tr>
                                        <td width="20%" style={{ textAlign: 'left', visibility: 'hidden' }}>
                                            <table className="hasprev hidden-xs" style={{ width: '100%', height: '100%', tableLayout: 'fixed' }}>
                                                <tbody><tr>
                                                    <td width="33px"><div className="prev left" /></td>
                                                    <td>
                                                        <div className="prevlbl left">
                                                            <div className="prevtitle " style={{ textAlign: 'left' }} />
                                                            <div className="prevname " style={{ textAlign: 'left' }}>Effective Gearing</div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                </tbody></table>
                                        </td>
                                        <td width="60%" style={{ textAlign: 'center' }}>
                                            <div id="pagetitlediv" style={{ width: '365px', height: '100%', borderBottom: '1px solid #FFD843', margin: 'auto' }}>
                                                <div id="ptitle" style={{ fontFamily: 'HelveticaNeueThinCond', fontSize: '25px', color: 'white', letterSpacing: '1px' }}>Useful Warrant terms</div>
                                                <div id="pname" style={{ fontFamily: 'HelveticaNeueThinCond', fontSize: '30px', color: '#FFD843', letterSpacing: '1px', paddingTop: '5px', paddingBottom: '5px' }}>Implied Volatility</div>
                                            </div>
                                        </td>
                                        <td width="20%" style={{ textAlign: 'right', visibility: 'hidden' }}>
                                            <table className="hasnext  hidden-xs" style={{ width: '100%', height: '100%', tableLayout: 'fixed' }}>
                                                <tbody><tr>
                                                    <td>
                                                        <div className="nextlbl right">
                                                            <div className="nexttitle " style={{ textAlign: 'right' }}>Next Topic</div>
                                                            <div className="nextname " style={{ textAlign: 'right' }}>How to select a Warrant?</div>
                                                        </div>
                                                    </td>
                                                    <td width="33px"><div className="next right" /></td>
                                                </tr>
                                                </tbody></table>
                                        </td>
                                    </tr>
                                    </tbody></table>
                            </div>
                            <div id="maincontent" style={{ marginLeft: '10px', marginRight: '10px', paddingTop: '40px', marginBottom: '60px' }}>
                                <div id="mainscroll" style={{ height: '100%', overflowX: 'hidden', overflowY: 'auto', paddingLeft: '90px', paddingRight: '90px' }}>
                                    <div id="mainscrollcontent">
                                        <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
                                        {/*<link rel="stylesheet" href="css/common.css"/>*/}
                                        <title>Implied Volatility</title>
                                        <style dangerouslySetInnerHTML={{ __html: "\n            .imgholder img{\n                max-width: 300px; \n/*                max-height: 270px; */\n            }\n            .contentbox table{\n                margin: 0 auto;\n            }\n            .contentbox table thead th{\n                background-color: #FFD400;\n            }\n            .contentbox table tbody td,\n            .contentbox table thead th{\n                height:2em;\n                padding:0 1em;\n                color:#000000;\n            }\n            .contentbox table tbody  tr:nth-child(even) td {background-color: #FFF4D2}\n            .contentbox table tbody  tr:nth-child(odd) td {background-color: #FFFF80}\n            .contentbox table tbody  tr.redtxt td {color:#FE3200}\n            .contentbox table thead th{\n                text-align:left;\n            }\n            .contentbox table tfoot td.disclaimer{\n                padding-top: 0.5em;\n                color: #FFFFFF;\n                font-size: 0.8em;\n            }\n            .listholder{\n                margin: 0 auto;\n            }\n            .listholder ul li{\n                line-height: 1.48em\n            }\n        " }} />
                                        <div className="contentbox">
                                            <p>
                                                Implied volatility is a key factor affecting a warrant’s pricing. It is the level of volatility that is implied by the current market price of the warrant, and represented as a percentage.<br /><br />
                                                Implied volatility can be used to compare the relative price of similar warrants. The higher the level, the more expensive the warrant (all other pricing factors held constant).<br /><br />
                                                Implied volatility is influenced by:
                                            </p>
                                            <div className="listholder" style={{ maxWidth: '480px' }}>
                                                <ul>
                                                    <li>Demand and supply forces</li>
                                                    <li>The level of volatility in market prices generally</li>
                                                    <li>Exchange traded options (ETO) and over the counter (OTC) markets</li>
                                                </ul>
                                            </div>
                                            <div className="imgholder">
                                                <img src='/img/education/impliedvolatility.png' alt="image" />
                                            </div>
                                            <p>Supposed you observe the price movement of Call Warrant A on the market to be as such:</p>

                                            <div className="imgholder">
                                                <img style={{ maxWidth: '800px' }} src='/img/education/iv_table1.png' alt="image" />
                                                <div className="map_pop">
                                                    <div
                                                        className="how_put"
                                                        data-bs-toggle="collapse"
                                                        href="#popup-image"
                                                        role="text"
                                                        aria-expanded="false"
                                                        aria-controls="popup-image"
                                                        onClick={() => { return setOpenLive(true), setImageUrl("/img/education/iv_tableMob1.png")}}
                                                    >View table
                                                    </div>
                                                </div>

                                            </div>
                                            <p>
                                                Call Warrant A is moving tick-for-tick with the underlying share price, moving up one ‘tick’ (MYR 0.005) for every one tick (MYR 0.01) in the underlying share with the implied volatility remaining constant.<br /><br />
                                                Later in the day, the price movements are as follows:
                                            </p>

                                            <div className="imgholder">

                                                <img style={{ maxWidth: '800px' }} src='/img/education/iv_table2.png' alt="image" />
                                                <div className="map_pop">
                                                    <div
                                                        className="how_put"
                                                        data-bs-toggle="collapse"
                                                        href="#popup-image"
                                                        role="text"
                                                        aria-expanded="false"
                                                        aria-controls="popup-image"
                                                        onClick={() => {return setOpenLive(true), setImageUrl("/img/education/iv_tableMob2.png")}}
                                                    >View table
                                                    </div>
                                                </div>

                                            </div>
                                            <p>
                                                As highlighted in red, price of Call Warrant A moved up one tick from MYR 0.160 to MYR 0.165 despite the underlying share price remaining unchanged at MYR 5.12. The increase in warrant price is attributed to the increase in implied volatility from 70% to 71%.<br /><br />
                                                <b>What may have caused the implied volatility to increase?</b>
                                            </p>
                                            <div className="listholder" style={{ maxWidth: '774px' }}>
                                                <ul>
                                                    <li>Increase in demand for the warrant, or</li>
                                                    <li>Market related event causing uncertainty in the market, hence, a higher forecast level of volatility in the market, or</li>
                                                    <li>An increase in the implied volatility level of a similar option in the ETO or OTC market.</li>
                                                </ul>
                                            </div>
                                            <p>
                                                Before the market closes, the training pattern of the underlying share and the call warrant are as follows:
                                            </p>

                                            <div className="imgholder">

                                                <img style={{ maxWidth: '800px' }} src='/img/education/iv_table3.png' alt="image" />
                                                <div className="map_pop">
                                                    <div
                                                        className="how_put"
                                                        data-bs-toggle="collapse"
                                                        href="#popup-image"
                                                        role="text"
                                                        aria-expanded="false"
                                                        aria-controls="popup-image"
                                                        onClick={() => {return setOpenLive(true), setImageUrl("/img/education/iv_tableMob3.png")}}
                                                    >View table
                                                    </div>
                                                </div>

                                            </div>
                                            <p>
                                                Call Warrant A continued to trade tick-for-tick with the underlying share up until 4:00pm when the call warrant declined from MYR 0.190 to MYR 0.185 even though the share price stayed put at MYR 5.16.<br /><br />
                                                <b>What may have caused the implied volatility to decrease?</b>
                                            </p>
                                            <div className="listholder" style={{ maxWidth: '774px' }}>
                                                <ul>
                                                    <li>Decrease in demand for the warrant, or</li>
                                                    <li>Increase in market confidence, hence, a lower forecast level of volatility in the market, or</li>
                                                    <li>Decrease in the implied volatility level of a similar option in the ETO or OTC market.</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="rightbar" className="hidden-xs" style={{ display: 'table-cell', width: '80px' }}>
                                </div>
                            </div>
                        </div>
                        <div id="rightbar" className="hidden-xs" style={{ display: 'table-cell', width: '80px' }}>
                        </div>
                    </div>
                </div>
            </div>

            <div
                id="bottom"
                style={{
                    position: "fixed",
                    width: "100%",
                    bottom: "0px",
                    height: "40px",
                    backgroundColor: "#101010",
                    zIndex: 10000,
                }}
            >
                <div
                    className="hidden-xs hidden-xxs"
                    style={{
                        display: "table",
                        width: "100%",
                        textAlign: "center",
                        color: "#8F8F8F",
                        fontSize: "11px",
                        lineHeight: "40px",
                    }}
                >
                    <div className='copyright_sec'>
                        Copyright (c) 2016 Macquarie Group Limited ABN 94 122 169 279. All rights
                        reserved.
                    </div>
                </div>
                <div
                    style={{
                        position: "absolute",
                        width: "46%",
                        height: "35px",
                        right: "10px",
                        bottom: "5px",
                    }}
                >
                    <table
                        className="hasnext"
                        style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                        <tbody>
                            <tr>
                                <td>
                                    <div className="nextlbl right">
                                        <div
                                            className="nextname "
                                            style={{ textAlign: "right", fontSize: "15px" }}
                                        ><Link to="/edu/select-warrant">
                                                How to select a Warrant?
                                            </Link>
                                        </div>
                                    </div>
                                </td>
                                <td width="33px">
                                    <Link to="/edu/select-warrant">
                                        <div className="next right" />
                                    </Link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div
                    style={{
                        position: "absolute",
                        width: "46%",
                        height: "35px",
                        left: "10px",
                        bottom: "5px",
                    }}
                >
                    <table
                        className="hasprev"
                        style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                        <tbody>
                            <tr>
                                <td width="33px">
                                    <Link to="/edu/useful-warrant-terms/effective-gearing">
                                        <div className="prev left" />
                                    </Link>
                                </td>
                                <td>
                                    <div className="prevlbl left">
                                        <div
                                            className="prevname "
                                            style={{ textAlign: "left", fontSize: "15px" }}
                                        ><Link to="/edu/useful-warrant-terms/effective-gearing">
                                                Effective Gearing
                                            </Link>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
           
            <div id="dotbar" className="hidden-sm hidden-xs" style={{}}>
                {/* <div className="dbtn dbtn-seminarbtn">
                    <Link
                        className="seminarbtn"
                        to="/education/seminar"
                    >
                        <img src='/img/education/button-static.png' alt="image" />
                    </Link>
                </div> */}
                <ChildInvestorAcademyCommon Location={location} Hist={history} />
                <SelectingWarrentImg Open={openLive} OpenModel={() => setOpenLive(!true)} Data={imageUrl}/>
            </div>

        </div>
    );
}
export default ImpliedVolatilities;